import 'css-chunksrc/client/scenes/workloads/wbs/task/allocationsList/details/styles.scss';export default {
  "main": "_main_wdxix_1",
  "groupMain": "_groupMain_wdxix_6",
  "item": "_item_wdxix_11",
  "groupItem": "_groupItem_wdxix_15",
  "placeholder": "_placeholder_wdxix_22",
  "addAllocation": "_addAllocation_wdxix_30",
  "iconBox": "_iconBox_wdxix_37",
  "icon": "_icon_wdxix_37",
  "list": "_list_wdxix_46"
};